import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { keyframes } from "@emotion/react";
 
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
 
const Loader = () => {
  const theme = useSelector((data) => data.themeValue.colors);
 
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: theme.background,
      }}
    >
      <Box
        sx={{
          border: "6px solid rgba(25, 118, 210, 0.3)",
          borderTop: "6px solid #1976d2",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          animation: `${spin} 1s linear infinite`,
        }}
      />
      <Typography
        variant="subtitle1"
        sx={{ mt: 2, color: theme.text }}
      >
        Loading, please wait...
      </Typography>
    </Box>
  );
};
 
export default Loader;